import React, { useEffect } from 'react'
import { UserProfilePageProps } from './UserProfilePage.types'
// import styles from './UserProfilePage.module.scss'
// import cl from 'classnames'
import { inject } from 'mobx-react'
import { USER_PROFILE_STORE } from 'store'
import { observer } from 'mobx-react-lite'
import { UserProfilePageBody } from '../UserProfilePageBody'

const UserProfilePageComponent = (props: UserProfilePageProps) => {
  const {
    // className,
    // style,
    [USER_PROFILE_STORE]: {
      getUser
    },
    match: {
      params: { userId }
    }
  } = props

  useEffect(() => getUser(userId), [getUser, userId])

  return (
    <UserProfilePageBody
      editAs='parent'
    />
  )
}

const UserProfilePage = inject(
  USER_PROFILE_STORE
)(observer(UserProfilePageComponent))
export { UserProfilePage }
